<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { useDictStore } from '@/store/dict'

const route = useRoute()
const dictStore = useDictStore()

// dictStore.fetchDebtTypes() 走的是 admin request (@/api/system → /api/admin/info-categories),
// 在 portal 前台不应该触发 —— 否则带过期 admin token 时会 401, 把用户从 portal 拉到 /admin/login。
// 仅在 admin 域 (路径以 /admin 开头, 但不是 /admin/login) 时拉取。
function maybeFetchDict() {
  const isAdminArea = route.path.startsWith('/admin') && route.path !== '/admin/login'
  if (isAdminArea) {
    dictStore.fetchDebtTypes()
  }
}

onMounted(maybeFetchDict)
// 路由切换进入 admin 域时也补拉一次 (首次 onMounted 可能落在 portal, dict 未拉)
watch(() => route.path, maybeFetchDict)
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  /* 注意：不要加 overflow: hidden。
     它本身困不住 teleport 到 <body> 的弹框，但会裁切任何未 teleport 的 fixed 元素，
     制造"弹框/抽屉被卡在某个区域"的玄学 bug。滚动由 .app-main 内部处理。 */
}
</style>
